import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
const root = (window.ufStorefront?.root || '/').replace(/\/?$/, '/');
const money = value => new Intl.NumberFormat(window.ufStorefront?.locale || 'en-US', {style:'currency',currency:window.ufStorefront?.currency || 'USD'}).format(value / 100);
const updateHeader = cart => {
  document.querySelectorAll('[data-uf-cart-count]').forEach(node => node.textContent = cart.item_count);
  document.querySelectorAll('[data-uf-cart-total]').forEach(node => node.textContent = money(cart.total_price));
};
window.ufCartAdded = async (cart, sections) => {
  updateHeader(cart);
  const result = {cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,itemCount:cart.item_count,sections,source:'uf-product',didError:false}};
  document.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[],promise:Promise.resolve(result)}));
};
let revision = 0;
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const current = ++revision;
  event.promise?.then(async ({detail}) => {
    if(detail?.didError)return;
    const response = await fetch(root + 'cart.js',{headers:{Accept:'application/json'}});
    if(!response.ok)return;
    const cart = await response.json();
    if(current === revision)updateHeader(cart);
  }).catch(() => {});
});
document.addEventListener('click', async event => {
  const link = event.target.closest('.uf-header-cart, [data-uf-open-cart]');
  const drawer = document.getElementById('cart-drawer');
  if(!link || !drawer || typeof drawer.open !== 'function' || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
  event.preventDefault();
  drawer.open();
});
